export default {
  liveDataSummary: 'Żądania zmieniają dane produkcyjne',
  liveDataDetails: 'Każde wysłane tutaj żądanie działa na danych produkcyjnych z Twoimi uprawnieniami. Zmiany i usunięcia obowiązują natychmiast i nie można ich cofnąć.',
};
